import script from "./DeviceC.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceC.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceC.vue?vue&type=style&index=0&id=b13134a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b13134a0"]])

export default __exports__